import { requestAxios } from 'services/api';
import { dashboardSummaryFactory } from 'factories';
import { DashboardSummary } from 'types';

interface GetDashboardSummaryParams {
  store?: string;
  startDate: number;
  endDate: number;
}

async function getDashboardSummary({
  store,
  startDate,
  endDate,
}: GetDashboardSummaryParams): Promise<DashboardSummary> {
  const params = {
    store,
    startDate,
    endDate,
  };

  const response = await requestAxios.get(`dashboard`, {
    params,
  });

  const result = response?.data ?? {};

  return dashboardSummaryFactory(result);
}

export const dashboardService = {
  getDashboardSummary,
};
